import { Component, OnInit, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.scss',
    imports: [TranslateModule],
    standalone: true,
})
export class FeedbackComponent implements OnInit {
    private http = inject(HttpClient);

    supportEmail = signal<string>('');
    private supportEmailUrl = './backend/public/configuration/';

    ngOnInit() {
        this.http.get<{ supportEmail: string }>(this.supportEmailUrl).subscribe((response) => {
            this.supportEmail.set(response.supportEmail);
        });
    }
}
